import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100a0bbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eventinfo" }
const _hoisted_2 = { class: "display-2 textcenter" }
const _hoisted_3 = { class: "eventarea" }
const _hoisted_4 = { class: "eventcontainer" }
const _hoisted_5 = { class: "mainarea" }
const _hoisted_6 = { class: "sidearea" }
const _hoisted_7 = {
  key: 0,
  class: "invitation mb-2"
}
const _hoisted_8 = { class: "textcenter size" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "textcenter size" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "textcenter size" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "timeandplace mb-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 textcenter mb-2" }, "Tid, sted & pris", -1))
const _hoisted_16 = { class: "size" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fra:", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { class: "eventcapitalize" }
const _hoisted_20 = { class: "size" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Til:", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = { class: "eventcapitalize" }
const _hoisted_24 = { class: "size" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sted:", -1))
const _hoisted_26 = {
  key: 0,
  class: "size"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pris: ", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Gratis")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "size"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pris:", -1))
const _hoisted_32 = {
  key: 1,
  class: "contactinfo mb-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 textcenter mb-2" }, "Kontaktinfo", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Arrangør: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Telefon: ", -1))
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 2,
  class: "contactinfo mb-2"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 textcenter mb-2" }, "Tilmelding", -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Telefon: ", -1))
const _hoisted_43 = ["href"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "navigation row justify--space-around" }
const _hoisted_48 = { class: "flex md3" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Til arrangementer")
const _hoisted_50 = { class: "flex md3" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Til forsiden")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, "Info om " + _toDisplayString(_ctx.eventData.eventTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eventData.eventDescription) = $event)),
            class: "description",
            readonly: "",
            noresize: ""
          }, null, 512), [
            [_vModelText, _ctx.eventData.eventDescription]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.eventData.eventInvitation.length > 0 && _ctx.eventData.eventInvitation !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("strong", null, [
                    (_ctx.eventData.eventInvitation[0] !== undefined)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.APIURL + _ctx.eventData.eventInvitation[0].url,
                          target: "_blank"
                        }, _toDisplayString(_ctx.eventData.eventInvitation[0].name), 9, _hoisted_9))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("strong", null, [
                    (_ctx.eventData.eventInvitation[1] !== undefined)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.APIURL + _ctx.eventData.eventInvitation[1].url,
                          target: "_blank"
                        }, _toDisplayString(_ctx.eventData.eventInvitation[1].name), 9, _hoisted_11))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("strong", null, [
                    (_ctx.eventData.eventInvitation[2] !== undefined)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.APIURL + _ctx.eventData.eventInvitation[2].url,
                          target: "_blank"
                        }, _toDisplayString(_ctx.eventData.eventInvitation[2].name), 9, _hoisted_13))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString((_ctx.eventData.eventStart !== null && _ctx.eventData.eventStart.length >= 1 ? _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.eventData.eventStart)) : '-')), 1)
            ]),
            _createElementVNode("p", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, _toDisplayString((_ctx.eventData.eventEnd !== null && _ctx.eventData.eventEnd.length >= 1 ? _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.eventData.eventEnd)) : '-')), 1)
            ]),
            _createElementVNode("p", _hoisted_24, [
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(_ctx.eventData.eventLocation), 1)
            ]),
            (_ctx.eventData.eventPrice === '' || _ctx.eventData.eventPrice === '0')
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _hoisted_29))
              : (_openBlock(), _createElementBlock("p", _hoisted_30, [
                  _hoisted_31,
                  _createTextVNode(" " + _toDisplayString(_ctx.eventData.eventPrice + ' kr.'), 1)
                ]))
          ]),
          (_ctx.eventData.clubName !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("p", null, [
                  _hoisted_34,
                  _createVNode(_component_router_link, {
                    to: {name: 'theClub', params: { slug: _ctx.eventData.clubSlug }, }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.eventData.clubName === 'Gæsteklubben' ? 'Dansk Dart Union' : _ctx.eventData.clubName)), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("p", null, [
                  _hoisted_35,
                  _createElementVNode("a", {
                    href: 'tel:' + _ctx.eventData.clubTelefon
                  }, _toDisplayString(_ctx.eventData.clubTelefon), 9, _hoisted_36)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_37,
                  _createElementVNode("a", {
                    href: 'mailto:' + _ctx.eventData.clubEmail
                  }, _toDisplayString(_ctx.eventData.clubEmail), 9, _hoisted_38)
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.eventData.extraContactTelephone !== '' && _ctx.eventData.extraContactTelephone !== null) || (_ctx.eventData.extraContactEmail !== '' && _ctx.eventData.extraContactEmail !== null))
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                (_ctx.eventData.extraContactTelephone !== '' && _ctx.eventData.extraContactTelephone !== null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("a", {
                        href: 'tel:' + _ctx.eventData.extraContactTelephone
                      }, _toDisplayString(_ctx.eventData.extraContactTelephone), 9, _hoisted_43)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.eventData.extraContactEmail !== '' && _ctx.eventData.extraContactEmail !== null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("a", {
                        href: 'mailto:' + _ctx.eventData.extraContactEmail
                      }, _toDisplayString(_ctx.eventData.extraContactEmail), 9, _hoisted_46)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_router_link, { to: { name: 'Eventlist' } }, {
            default: _withCtx(() => [
              _hoisted_49
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_51
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}